const Features = {
	FEATURE_TEST: "FEATURE_TEST",
	FEATURE_TOTALSTATION: "FEATURE_TOTALSTATION",
	FEATURE_RSU_NEAR_NEIGHBOR: "RSU_NEAR_NEIGHBOR",
	DASHBOARD: "DASHBOARD",
	TIM_INDEX: "TIM_INDEX",
	LEGACY_TFR_ENTRY: "LEGACY_TFR_ENTRY",
	WORKER_PRESENCE: "WORKER_PRESENCE",
	RSU_NTCIP1218_CONFIG: "RSU_NTCIP1218_CONFIG",
	FLOOD_DSS: "FLOOD_DSS",
	FLEET_MANAGEMENT: "FLEET_MANAGEMENT"
};

export default Features;
